"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marketActivityCancel = marketActivityCancel;
exports.marketActivityDelete = marketActivityDelete;
exports.marketActivityGetSetting = marketActivityGetSetting;
exports.marketActivityInfo = marketActivityInfo;
exports.marketActivityList = marketActivityList;
exports.marketActivityPublish = marketActivityPublish;
exports.marketActivityPullDown = marketActivityPullDown;
exports.marketActivitySave = marketActivitySave;
exports.marketActivityUpdate = marketActivityUpdate;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 新增
 * @param
 */
function marketActivitySave(pram) {
  return (0, _request.default)({
    url: '/admin/platform/market_activity/save',
    method: 'POST',
    data: pram
  });
}

/**
 * 分页列表
 * @param
 */
function marketActivityList(pram) {
  var data = {
    page: pram.page,
    limit: pram.limit
  };
  if (pram.activityName) {
    data.activityName = pram.activityName;
  }
  if (pram.form && pram.to) {
    data.form = pram.form;
    data.to = pram.to;
  }
  if (pram.marketId !== '' && pram.marketId >= 0) {
    data.marketId = pram.marketId;
  }
  if (pram.processStatus !== '' && pram.processStatus >= 0) {
    data.processStatus = pram.processStatus;
  }
  if (pram.status !== '' && pram.status >= 0) {
    data.status = pram.status;
  }
  return (0, _request.default)({
    url: '/admin/platform/market_activity/list',
    method: 'get',
    params: data
  });
}
/**
 * 修改
 * @param
 */
function marketActivityUpdate(pram) {
  return (0, _request.default)({
    url: "/admin/platform/market_activity/update?id=".concat(pram.id),
    method: 'post',
    data: pram
  });
}
/**
 * 删除
 * @param
 */
function marketActivityDelete(id) {
  var data = {
    id: id
  };
  return (0, _request.default)({
    url: "/admin/platform/market_activity/delete?id=".concat(id),
    method: 'get',
    params: data
  });
}
/**
 * 详情
 * @param
 */
function marketActivityInfo(id) {
  var data = {
    id: id
  };
  return (0, _request.default)({
    url: "/admin/platform/market_activity/info",
    method: 'get',
    params: data
  });
}
/**
 * 上架
 * @param
 */
function marketActivityPublish(data) {
  return (0, _request.default)({
    url: "/admin/platform/market_activity/publish?id=".concat(data.id),
    method: 'post',
    data: data
  });
}
/**
 * 下架
 * @param
 */
function marketActivityPullDown(pram) {
  return (0, _request.default)({
    url: "/admin/platform/market_activity/pullDown?id=".concat(pram.id),
    method: 'post',
    data: pram
  });
}
/**
 * 获取报名默认配置信息
 */
function marketActivityGetSetting() {
  return (0, _request.default)({
    url: '/admin/platform/market_activity/getSetting',
    method: 'get'
  });
}

/**
 * 取消活动
 */
function marketActivityCancel(data) {
  return (0, _request.default)({
    url: "/admin/platform/market_activity/cancel?id=".concat(data.id),
    method: 'post',
    data: data
  });
}